<template>
  <PullRefresh
    v-model="isLoading"
    success-text="刷新成功"
    :disabled="disabledPull || !isLive"
    @refresh="onRefresh"
  >
    <div v-if="isNotStart" class="pageNative flex_center">
      <div
        class="nativeStatus flex_center"
      >
        活动将于 {{ activityInfo.startTime }} 开始
      </div>
    </div>
    <div v-else class="page">
      <!-- 头图 -->
      <div
        class="page_header bg_contain"
        :style="{
          backgroundImage: `url(${activityInfo.banner})`,
        }"
      >
      </div>
      <div class="main">
        <div
          v-if="pkRounds.length > 1"
          class="round_ctx bg_contain flex_evenly"
          :style="{
            backgroundImage: `url(${CDN_URL}/round.png?v=1)`,
          }"
        >
          <div
            v-for="(rod, rIdx) in pkRounds"
            :key="rod.round"
            class="round_item flex_1 flex_center fs_12"
            :class="{
              color_black: activeRound === rod.round,
              fs_14: activeRound === rod.round,
            }"
            :style="{
              // backgroundImage: activeRound === rod.round ? `url(${CDN_URL}/select${rIdx === 0 ? 1 : (rIdx === (pkRounds.length - 1) ? 3 : 2)}.png)` : '',
            }"
            @click="onRoundClick(rod)"
          >
            <div v-if="activeRound === rod.round" class="round_item_bg flex_center">
              <div
                :style="{
                  backgroundImage: `url(${CDN_URL}/high_${rIdx ? 'left' : 'right'}.png?v=1)`,
                  transform: rIdx ? 'translateX(1px)' : 'rotate(180deg) translateX(-1px)',
                }"
                class="bg_contain round_item_bg_1"
              ></div>
              <div
                :style="{ backgroundImage: `url(${CDN_URL}/high_mid.png)` }"
                class="bg_contain round_item_bg_2 flex_1"
              ></div>
              <div
                :style="{
                  backgroundImage: `url(${CDN_URL}/high_${rIdx === (pkRounds.length - 1)  ? 'right' : 'left'}.png?v=1)`,
                  transform: rIdx === (pkRounds.length - 1) ? 'translateX(-1px)' : 'rotate(180deg) translateX(1px)',
                }"
                class="bg_contain round_item_bg_3"
              ></div>
            </div>
            <span
              v-for="(str, sIdx) in onSplitStringByParentheses(rod.roundName)"
              :key="(str + sIdx)"
              :class="{
                text_highlight_1: str.includes('('),
                bold: activeRound === rod.round,
              }"
              style="position: relative; z-index: 1;"
            >{{ onRemoveTag(str) }}</span>
          </div>
        </div>
        <div
          class="battle_ctx mt_6 bg_contain"
          :style="{
            backgroundImage: `url(${CDN_URL}/battle.png?v=1)`,
          }"
        >
          <div
            v-if="curRound.pkStatus !== 0"
            class="title bg_contain"
            :style="{
              backgroundImage: `url(${CDN_URL}/title_bg.png?v=1)`,
            }"
          >
            加入支持队伍，获胜分5000元代金券
          </div>
          <div class="counter_ctx flex_center mt_6">
            <!-- 正在进行 -->
            <template v-if="curRound.pkStatus === 1">
              <div class="counter_label mr_16">倒计时</div>
              <div class="counter_main flex_center pb_2 pt_2">
                <div class="counter_time counter_day">
                  <div class="counter_time_num">{{ countdown[0] }}</div>
                  <div class="counter_time_unit">天</div>
                </div>
                <div class="counter_sperator">:</div>
                <div class="counter_time counter_hour">
                  <div class="counter_time_num">{{ countdown[1] }}</div>
                  <div class="counter_time_unit">时</div>
                </div>
                <div class="counter_sperator">:</div>
                <div class="counter_time counter_min">
                  <div class="counter_time_num">{{ countdown[2] }}</div>
                  <div class="counter_time_unit">分</div>
                </div>
                <div class="counter_sperator">:</div>
                <div class="counter_time counter_sec">
                  <div class="counter_time_num">{{ countdown[3] }}</div>
                  <div class="counter_time_unit">秒</div>
                </div>
              </div>
            </template>
            <!-- 已结束 -->
            <div v-if="curRound.pkStatus === 2" class="battle_over text_center color_white mt_24 mb_8 fs_18 bold">
              PK已结束！
            </div>
          </div>
          <div class="battle_main">
            <!-- PK未开始 -->
            <div
              v-if="curRound.pkStatus === 0"
              class="battle_not_start flex_center"
              style="height: 253px"
            >
              <span>PK将于</span>
              <span style="color: #fdcb45">{{ curRound.pkStartTime }}</span>
              <span>开始</span>
            </div>
            <!-- 比赛开始 -->
            <div v-if="[1, 2].includes(curRound.pkStatus)" class="battle_ing">
              <!-- 选队伍期间 -->
              <div v-if="curRound.pkStatus === 1 && !curRound.userJoinTeam" class="battle_choose bg_contain">
                <div class="battle_team battle_team_1 bold">{{ curRound.blueName }}</div>
                <div class="battle_team battle_team_2 bold">{{ curRound.redName }}</div>
                <div class="battle_join bg_contain battle_join_1" @click="onJoinTeam('blue')"></div>
                <div class="battle_join bg_contain battle_join_2" @click="onJoinTeam('red')"></div>
              </div>
              <!-- 正式加入队伍 -->
              <div v-else class="battle_start mt_16">
                <!-- pk 进度 -->
                <div
                  class="battle_progress mb_8"
                  :style="{
                    background: `linear-gradient(90deg, #7D7DFD 0, #95DBFF ${battlePercent}%)`
                  }"
                >
                  <!-- 蓝队领先文案 -->
                  <div
                    class="battle_progress_box battle_blue_text flex_center"
                    :style="{ width: `${battlePercent}%` }"
                  >
                    <div
                      v-if="curRound.winTeam === 'blue'"
                      class="battle_progress_img bg_contain"
                      :style="{
                        backgroundImage: `url(${CDN_URL}/victory.png?v=1)`,
                      }"
                    ></div>
                    <div v-if="curRound.pkStatus === 1 && (curRound.userJoinTeam === 'blue' || curRound.blueScore === curRound.redScore)" class="battle_progress_text">
                      {{ getPkText(curRound.blueScore, curRound.redScore) }}
                    </div>
                  </div>
                  <!-- 红队领先文案 -->
                  <div
                    
                    class="battle_progress_box battle_red_text flex_center"
                    :style="{ width: `${100 - battlePercent}%` }"
                  >
                    <div
                      v-if="curRound.winTeam === 'red'"
                      class="battle_progress_img bg_contain"
                      :style="{
                        backgroundImage: `url(${CDN_URL}/victory.png?v=1)`,
                      }"
                    ></div>
                    <div v-if="curRound.pkStatus === 1 && (curRound.userJoinTeam === 'red' || curRound.blueScore === curRound.redScore)" class="battle_progress_text">
                      {{ getPkText(curRound.redScore, curRound.blueScore) }}
                    </div>
                  </div>
                  <!-- 红队进度 -->
                  <div
                    class="battle_red"
                    :style="{ background: `linear-gradient(116deg, transparent 0, transparent ${battlePercent}%, #FDCB45 ${battlePercent}%, #FDCB45 100%)` }"
                  ></div>
                  <!-- <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); background-color: #fff; width: 4px;height: 4px;"></div> -->
                  <div
                    v-if="curRound.pkStatus === 1"
                    class="battle_versus_img bg_contain"
                    :style="{
                      left: `${battlePercent}%`,
                      backgroundImage: `url(${CDN_URL}/vs.png?v=1)`,
                      transform: `translateX(${vsTransformX}rem)`,
                    }"
                  ></div>
                  <!-- fighting 水印 -->
                  <div
                    class="battle_progress_mark bg_contain"
                    :style="{
                      backgroundImage: `url(${CDN_URL}/mark1.png?v=1)`,
                    }"
                  ></div>
                </div>
                <div class="battle_info flex_between">
                  <div class="battle_info_bule">
                    <div class="battle_info_name mb_10 flex_a_c">
                      <div class="fs_15 bold">{{ curRound.blueName }}</div>
                      <div v-if="curRound.userJoinTeam === 'blue'" class="battle_info_tag bg_contain" :style="{ backgroundImage: `url(${CDN_URL}/my_team.png?v=1)` }"></div>
                    </div>
                    <div class="battle_info_score fs_13 color_gold bold">幸运点：{{ curRound.blueScore }}</div>
                  </div>
                  <div class="battle_info_red">
                    <div class="battle_info_name mb_10 flex_a_c">
                      <div class="fs_15 bold">{{ curRound.redName }}</div>
                      <div v-if="curRound.userJoinTeam === 'red'" class="battle_info_tag bg_contain" :style="{ backgroundImage: `url(${CDN_URL}/my_team.png?v=1)` }"></div>
                    </div>
                    <div class="battle_info_score fs_13 color_gold bold">幸运点：{{ curRound.redScore }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="task_ctx mt_16">
          <div class="task_ctx_title"></div>
          <div v-if="pkRounds.length" class="reward_enter bold" @click="onShowRewardRecord">奖励明细</div>
          <div class="task_list_wrap">
            <div class="task_list">
              <div
                v-for="tk in taskList"
                :key="tk.taskId"
                class="task_item flex_center"
              >
                <div class="task_icon"></div>
                <div class="task_info">
                  <div class="task_title van-ellipsis">
                    <span
                      v-for="(str, sIdx) in onSplitStringByParentheses(tk.taskName)"
                      :key="(str + sIdx)"
                      class="bold"
                      :class="{ text_highlight_2: str.includes('(') }"  
                    >{{ onRemoveTag(str) }}</span>
                  </div>
                  <div class="task_credit">+{{ tk.credit }} 幸运点</div>
                </div>
                <div
                  class="task_btn flex_center"
                  :class="{
                    btn_bg_1: [3].includes(tk.completeStatus),
                    btn_bg_2: [1].includes(tk.completeStatus),
                    btn_bg_3: [2, 4, 5].includes(tk.completeStatus),
                  }"
                  @click="onTaskBtnClick(tk)"
                >
                  {{ taskBtnStrMap[tk.completeStatus] }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ActivityPopup
      class="pk_game_popup"
      :visible.sync="visible"
      confirmButtonColor="#FE732E"
      cancelButtonColor="#afafaf"
      v-bind="feedback"
      :headerStyle="{
        background: '#FE732E'
      }"
      @confirm="feedback.onSure"
      @cancel="feedback.onCancel"
    >
      <div class="mt_18 mb_18" v-if="feedbackType === 0">
        <p class="color_black text_center">确定加入{{ preSelectTeamName }}？</p>
        <p class="color_grey text_center fs_12">加入后本轮次PK将无法变更队伍</p>
      </div>
      <div class="mt_32 mb_32" v-if="feedbackType === 1">
        <p class="color_black text_center">
          {{ getTaskErrorText() }}
          （<span class="color_red_btn">{{ progressOfTask[0] }}</span>/{{ progressOfTask[1] }}）
        </p>
      </div>
      <div class="" v-if="feedbackType === 2">
        <div class="color_black fs_12 mb_12 pl_4" style="text-align: left;">
          {{ getTaskErrorText() }}
          （<span class="color_red_btn">{{ progressOfTask[0] }}</span>/{{ progressOfTask[1] }}）
        </div>
        <div class="task_game_list">
          <div v-for="game in recommendList" :key="game.gameId" class="task_game_item">
            <div class="task_game_icon bg_contain" :style="{ backgroundImage: `url(${game.gameIcon})` }"></div>
            <div class="task_game_info">
              <div class="task_game_title">{{ game.gameName }}</div>
              <div class="task_game_desc">{{ game.introduce }}</div>
            </div>
            <div
              class="task_game_btn fs_12 flex_center"
              :class="{
                task_game_check: installedPkgs.includes(game.packageName),
                task_game_download: !installedPkgs.includes(game.packageName),
              }"
              @click="handleClickGame(game)"
            >
              {{ game.packageName && installedPkgs.includes(game.packageName) ? '查看' : '下载' }}
            </div>
          </div>
        </div>
      </div>
      <div class="result_pop mt_8" v-if="[3, 4, 5, 6].includes(feedbackType)">
        <div class="result_title text_center fs_18 mb_18">{{ gotWin ? '本次PK大获全胜，赢得' : '就差一点就获胜了' }}</div>
        <div class="result_content flex_center mb_12">
          <div
            class="result_icon bg_contain"
            :style="{
              backgroundImage: `url(${userReward.rewardIcon})`,
            }"
          ></div>
          <div class="result_main ml_12">
            <template v-if="userReward.rewardType === 2">
              <p style="text-align: left;">您将获得 {{ userReward.rewardName }}，</p>
              <p style="text-align: left;">下次一定赢</p>
            </template>
            <template v-else>
              <p style="text-align: left;">{{ userReward.rewardName }}</p>
              <p class="fs_12" style="margin-bottom: 0;">{{ invalidTimeByType }}</p>
            </template>
          </div>
        </div>
        <div class="result_desc">
          <template v-if="userReward.rewardType === 2">
            <p>积分可用在【积分商城】兑换</p>
            <p>游戏道具</p>
          </template>
          <template v-else>
            <p>代金券已存放在</p>
            <p>【我的】--【代金券】</p>
          </template>
        </div>
      </div>
    </ActivityPopup>
    <ActivityPopup
      :visible.sync="downloadVisible"
      title="提示"
      confirmButtonColor="#FE732E"
      cancelButtonColor="#afafaf"
      :message="['已有游戏角色', '下载后无法获得幸运点，是否继续下载']"
      confirmButtonText="继续下载"
      cancelButtonText="取消"
      showCancelButton
      @confirm="handleDownload"
      @cancel="handleCancelDownload"
    >

    </ActivityPopup>
    <Record ref="recordRef" :activityId="actId" :round="activeRound" />
  </PullRefresh>
</template>

<script>
import {
  setPageTitle,
  toLogin,
  jumpToNative,
  clickRightTxt,
  setRightTxtColor,
  setRightTxt,
  isInstalledPackage,
} from "@/bridge/AppJsBridge";
import { PullRefresh } from "vant";
import {
  getPkMainInfo, joinPkTeam, getTasksApi,
  onCompleteTask, getRecommendGames,
} from '@/apis/wxActivity'
import ActivityPopup from "@/components/btBox/ActivityPopup";
import EventTrack from '@/mixins/eventTrack'
import { CDN_URL_1 } from "@/config";
import moment from 'moment';
import Record from './record'

const LOCAL_STORE_KEY = 'pk_activity_result_info'

export default {
  components: {
    PullRefresh,
    ActivityPopup,
    Record,
  },
  mixins: [EventTrack],
  data () {
    return {
      isWx: true,
      CDN_URL: CDN_URL_1 + '/box_pk',
      activityInfo: {
        activityId: '',
        startTime: "",
        name: "",
        banner: "",
        endTime: "",
        pkRoundVoList: [],
        currentTime: '',
      },
      disabledPull: false,
      downloadVisible: false,
      visible: false,
      feedbackType: 0,
      recommendList: [],
      taskList: [],
      isLoading: false,
      activeRound: 1, // 当前选中的轮次
      countdown: ['00', '00', '00', '00'],
      interval: null,
      preSelectTeam: '', // 预选的队伍
      taskBtnStrMap: {
        1: '领取',
        2: '已领取',
        3: '去完成',
        4: '未开始',
        5: '已结束',
      },
      progressOfTask: [],
      taskErrorCode: 0,
      installedPkgs: [], // 已安装的包
      showTheRound: {}, // 当前展示结果的轮次
      curGameInfo: {}, // 当前游戏信息
      curTaskInfo: {}, // 当前任务信息
    }
  },
  computed: {
    battlePercent () {
      const { redScore, blueScore } = this.curRound
      const score = blueScore || 1
      const total = (redScore + blueScore) || 2
      return score / total * 100
      // return 75
    },
    vsTransformX () {
      // 42 -> 图片中心偏移量
      // 26 -> 116deg - 90deg
      // Math.tan((26 * Math.PI) / 180) * 60 -> 改角度下 X 轴偏移量
      // 75 -> px to rem
      const px = -42 - Math.cos(Math.PI * (this.battlePercent / 100)) * Math.tan((26 * Math.PI) / 180) * 60 / 3
      return px / 75
    },
    preSelectTeamName () {
      const { blueName, redName } = this.curRound
      return this.preSelectTeam === 'blue' ? blueName : redName
    },
    selectedTeamName () {
      const { blueName, redName, userJoinTeam } = this.curRound
      return userJoinTeam === 'blue' ? blueName : redName
    },
    actId () {
      return this.$route.query.id
    },
    isLive () {
      const { currentTime, startTime, endTime } = this.activityInfo
      if (!this.hasFetched) return true
      if (!this.actId) return false
      return moment(currentTime).isBetween(moment(startTime), moment(endTime))
    },
    isNotStart () {
      const { currentTime, startTime } = this.activityInfo
      return moment(currentTime).isBefore(moment(startTime))
    },
    pkRounds () {
      return this.activityInfo.pkRoundVoList || []
    },
    curRound () {
      return this.pkRounds.find(item => item.round === this.activeRound) || {}
    },
    isShowTheLastRound () {
      const f = this.showTheRound.round && (this.showTheRound.round === this.pkRounds[this.pkRounds.length - 1].round)
      return f
    },
    gotWin () {
      return [4, 6].includes(this.feedbackType)
    },
    userReward () {
      return this.showTheRound.userRewardVo || {}
    },
    invalidTimeByType () {
      const { invalidTime } = this.userReward
      return `有效时间: ${invalidTime}`
    }, 
    feedback () {
      return this.feedbackMap[this.feedbackType]
    },
    feedbackMap () {
      return [
        {
          title: '加入队伍提醒',
          message: [],
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          showCancelButton: true,
          onSure: () => {
            this.eventTrack({
              event: "newly_register_join_team_affirm_button",
              event_field: this.getTrackInfo({
                team_name: this.preSelectTeamName,
                type: 2,
              }),
            })
            this.handleSureJoin()
          },
          onCancel: () => {
            this.eventTrack({
              event: "newly_register_join_team_affirm_button",
              event_field: this.getTrackInfo({
                team_name: this.preSelectTeamName,
                type: 1,
              }),
            })
            this.triggerVisible(false)
          }
        },
        {
          title: '任务提示',
          message: [],
          confirmButtonText: '确认',
          onSure: () => {
            this.triggerVisible(false)
          },
          onCancel: () => {
            this.triggerVisible(false)
          }
        },
        {
          title: '推荐游戏',
          message: [],
          confirmButtonText: '确认',
          showConfirmButton: false,
          onSure: () => {
            this.triggerVisible(false)
          },
          onCancel: () => {
            this.triggerVisible(false)
          }
        },
        {
          title: '好可惜',
          message: [],
          confirmButtonText: '继续PK',
          cancelButtonText: this.userReward.rewardType === 1 ? '查看代金券' : '去使用积分',
          showCancelButton: true,
          cancelButtonColor: 'transparent',
          onSure: () => {
            this.onSureContinue()
          },
          onCancel: () => {
            this.onGoCheckReward()
          },
        },
        {
          title: '恭喜您',
          message: [],
          confirmButtonText: '继续PK',
          cancelButtonText: this.userReward.rewardType === 1 ? '查看代金券' : '去使用积分',
          showCancelButton: true,
          onSure: () => {
            this.onSureContinue()
          },
          onCancel: () => {
            this.onGoCheckReward()
          },
        },
        {
          title: '好可惜',
          message: [],
          confirmButtonText: this.userReward.rewardType === 1 ? '查看代金券' : '去使用积分',
          cancelButtonColor: 'transparent',
          onSure: () => {
            this.onGoCheckReward()
          },
          onCancel: () => {
            this.triggerVisible(false)
          },
        },
        {
          title: '恭喜您',
          message: [],
          confirmButtonText: this.userReward.rewardType === 1 ? '查看代金券' : '去使用积分',
          onSure: () => {
            this.onGoCheckReward()
          },
          onCancel: () => {
            this.triggerVisible(false)
          },
        },
      ]
    },
  },
  mounted () {
    // 如果浏览器没有调用接口，可以加上 IS_DEV 的 query 参数
    const { query } = this.$route
    if (query.IS_DEV) {
      this.init()
    }
    this.getAppToken(true)
  },
  activated () {
    setPageTitle(this.activityInfo.name)
    if (this.activityInfo.name) {
      setRightTxt('活动规则');
    }
  },
  methods: {
    init () {
      this.getRecommendGameList()
      return this.getActInfo().then(res => {
        setPageTitle(this.activityInfo.name)
        this.eventTrack({
          event: "newly_register_page",
          event_field: this.getTrackInfo({}),
        })
      }).finally(() => {
        this.setHeaderContent()
      })
    },
    getActivityInfo () {
      this.init()
    },
    onRefresh () {
      this.init().finally(res => {
        setTimeout(() => {
          this.isLoading = false
        }, 500)
      })
    },
    getActInfo () {
      return getPkMainInfo({
        activityId: this.actId,
      }).then(res => {
        this.activityInfo = res.data || {
          activityId: '',
          startTime: "",
          name: "",
          banner: "",
          endTime: "",
          pkRoundVoList: [],
          currentTime: '',
        }

        this.onAutoSelectRound()
        this.getTaskList()
        this.$nextTick(() => {
          this.calcCounter()
        })
      })
        .catch((error) => {
          const errorInfo = error.response;
          const { data } = errorInfo;
          if (data && data.code === 401) {
            toLogin("/loginKey/LoginByKeyPhoneActivity");
          }
        })
        .finally(() => {
          this.hasFetched = true
        })
    },
    // 当前应该展示第几轮
    onAutoSelectRound () {
      const list = this.pkRounds
      const i_0 = list.findIndex(item => item.pkStatus === 0)
      const i_1 = list.findIndex(item => item.pkStatus === 1)
      this.$nextTick(() => {
        this.onShowEndRoundResult()
      })

      if (i_1 === -1) {
        if (i_0 !== -1) {
          this.activeRound = list[i_0].round
          return
        }

        if (list.every(item => item.pkStatus === 2)) {
          this.activeRound = list[list.length - 1].round
          return 
        }
      }
      this.activeRound = list[i_1].round
    },
    // 展示已结束的轮次结果
    onShowEndRoundResult () {
      const showedList = this.getHadSeenRounds()
      // 已有结果的轮次
      const roundsWhichHasResult = this.pkRounds.filter(v => !!v.userRewardVo)
      const theRoundIds = roundsWhichHasResult.map(v => v.round)
      // 应该展示的轮次
      const showRounds = theRoundIds.filter(v => !showedList.includes(v))
      // debugger
      if (Array.isArray(showRounds) && showRounds.length > 0) {
        const show_the_round = showRounds[showRounds.length - 1]
        this.showTheRound = this.pkRounds.find(v => v.round === show_the_round)
        const isWin = this.showTheRound.userRewardVo.type === 1

        this.$nextTick(() => {
          this.setSeenRounds(show_the_round)
          this.triggerVisible(
            true,
            isWin ? (this.isShowTheLastRound ? 6 : 4) : (this.isShowTheLastRound ? 5 : 3)
          )
          this.eventTrack({
            event: "newly_register_pk_result_pop",
            event_field: this.getTrackInfo({
              team_name: this.showTheRound[this.showTheRound.userJoinTeam + 'Name'],
              round_name: this.showTheRound.roundName,
              pk_result: isWin ? 1 : 2,
            }),
          })
        })
      }
    },
    getRecommendGameList () {
      this.installedPkgs = []
      getRecommendGames({
        activityId: this.actId,
      }).then(res => {
        this.recommendList = res.data || []
        const sourcePkgs = this.recommendList.map(it => it.packageName).join(',')
        console.log('sourcePkgs', sourcePkgs)
        isInstalledPackage(sourcePkgs, res => {
          this.installedPkgs = res.split(',').filter(it => it)
          console.log('has Installed', this.installedPkgs)
          this.onSortGames()
        })
      })
    },
    // 将推荐游戏排序
    onSortGames () {
      // 已安装的游戏排在后面
      this.recommendList.sort((a, b) => {
        if (this.installedPkgs.includes(a.packageName)) {
          if (this.installedPkgs.includes(b.packageName)) {
            return a.sort - b.sort
          }
          return 1
        } else if (this.installedPkgs.includes(b.packageName)) {
          if (this.installedPkgs.includes(a.packageName)) {
            return a.sort - b.sort
          }
          return -1
        } else {
          return a.sort - b.sort
        }
      })
    },
    // 点击下载/查看按钮
    handleClickGame (game) {
      this.curGameInfo = game
      const { play, gameId, gameName } = game
      const hasInstalled = this.installedPkgs.includes(game.packageName)

      this.eventTrack({
        event: "newly_register_down_view_button",
        event_field: this.getTrackInfo({
          team_name: this.selectedTeamName,
        }),
        appkey: gameId,
        appName: gameName,
      })

      // 如果未下载且有市场包在玩记录，给出弹窗提示
      if (play && !hasInstalled) {
        this.eventTrack({
          event: "game_transfer_down_pop",
          event_field: this.trackActInfo,
          appkey: gameId,
          appName: gameName,
        })
        this.downloadVisible = true
        return
      }
      this.handleGoGameDetail()
    },
    handleDownload () {
      const { gameId, gameName } = this.curGameInfo
      this.downloadVisible = false
      this.handleGoGameDetail()
      this.eventTrack({
        event: "game_transfer_cancel_go_on_button",
        event_field: this.getTrackInfo({
          type: 2,
        }),
        appkey: gameId,
        appName: gameName,
      })
    },
    handleCancelDownload () {
      this.downloadVisible = false
    },
    // 跳转原生游戏详情    
    handleGoGameDetail () {
      const { gameId } = this.curGameInfo
      const data = {
        routePath: "/main/game/GameDetailActivity",
        fromPageType: 59,
        extraParams: gameId,
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    getTaskList () {
      getTasksApi({
        activityId: this.actId,
        round: this.activeRound,
      }).then(res => {
        this.taskList = res.data || []
      })
    },
    // 点击轮次
    onRoundClick (rod) {
      const { round } = rod
      if (round === this.activeRound) return
      this.activeRound = round
      this.getTaskList()

      this.eventTrack({
        event: "newly_register_pk_round_navigate",
        event_field: this.getTrackInfo({}),
      })

      this.$nextTick(() => {
        this.calcCounter()
      })
    },
    // 加入 pk 队伍
    onJoinTeam (joinTeam) {
      this.eventTrack({
        event: "newly_register_join_team_button",
        event_field: this.getTrackInfo({
          team_name: this.curRound[`${joinTeam}Name`]
        }),
      })
      this.preSelectTeam = joinTeam
      this.triggerVisible(true, 0)
      this.eventTrack({
        event: "newly_register_join_team_alert_pop",
        event_field: this.getTrackInfo({
          team_name: this.curRound[`${joinTeam}Name`]
        }),
      })
    },
    // 确认加入
    handleSureJoin () {
      joinPkTeam({
        activityId: this.actId,
        joinTeam: this.preSelectTeam,
        round: this.activeRound,
      }).then(res => {
        this.triggerVisible(false)
        this.getActInfo()
      })
    },
    // 定时器处理
    calcCounter () {
      this.clearIntervalIns()
      let now = moment(this.activityInfo.currentTime);
      const endTime = this.curRound.pkEndTime;
      if (!endTime) {
        this.clearIntervalIns()
        this.countdown = ['00', '00', '00', '00']
        return
      }
      this.interval = setInterval(() => {
        now.add(1, 's');
        const end = moment(endTime);
        const duration = moment.duration(end.diff(now));

        if (duration.asSeconds() <= 0) {
          this.clearIntervalIns()
          this.countdown = ['00', '00', '00', '00']
          return
        }

        // 计算剩余天、小时、分钟、秒
        const days = duration.days().toString().padStart(2, '0');
        const hours = duration.hours().toString().padStart(2, '0');
        const minutes = duration.minutes().toString().padStart(2, '0');
        const seconds = duration.seconds().toString().padStart(2, '0');

        this.countdown = [days, hours, minutes, seconds];
      }, 1000)
    },
    clearIntervalIns () {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
    },
    // 打开奖励记录面板
    onShowRewardRecord () {
      this.eventTrack({
        event: "newly_register_credit_detail_button",
        event_field: this.getTrackInfo({
          team_name: this.selectedTeamName,
        }),
      })
      this.$refs.recordRef.triggerVisible(true)
    },
    // 任务列表按钮点击
    onTaskBtnClick (tk = {}) {
      this.curTaskInfo = tk
      const { taskId, taskName, completeStatus } = tk
      if ([2, 4, 5].includes(completeStatus)) return
      if (!this.curRound.userJoinTeam) {
        this.$toast('请加入任意队伍')
        return
      }
      this.eventTrack({
        event: "newly_register_task_button",
        event_field: this.getTrackInfo({
          task_id: taskId,
          task_name: taskName,
          team_name: this.selectedTeamName,
          type: completeStatus === 1 ? 2 : 1,
        }),
      })
      onCompleteTask({
        taskId,
        round: this.activeRound,
      }).then(res => {
        // const {} = res.data
        this.$toast.success('领取成功')
        this.getActInfo()
      }).catch(error => {
        const { code, msg } = error
        console.log(error)
        if ([94109, 94110, 94111].includes(code)) {
          const [a, b] = msg.split('/')
          this.progressOfTask = [a, b]
          this.taskErrorCode = code
          if (code === 94109) {
            this.eventTrack({
              event: "newly_register_recommend_game_pop",
              event_field: this.getTrackInfo({
                task_id: taskId,
                task_name: taskName,
                team_name: this.selectedTeamName,
                complete_value: a * 1,
                condition_value: b * 1,
              }),
            }) 
          } else {
            this.eventTrack({
              event: "newly_register_task_hint_pop",
              event_field: this.getTrackInfo({
                task_id: taskId,
                task_name: taskName,
                team_name: this.selectedTeamName,
                complete_value: a * 1,
                condition_value: b * 1,
              }),
            })
          }
          this.triggerVisible(true, code === 94109 ? 2 :1)
          return
        }
        this.$toast(msg)
      })
    },
    getTaskErrorText () {
      const code = this.taskErrorCode
      if (code === 94109) {
        return `下载推荐游戏 ${this.progressOfTask[1]} 款`
      }
      if (code === 94110) {
        return `游戏内充值达 ${this.progressOfTask[1]} 元`
      }
      if (code === 94111) {
        return `游戏内充值达 ${this.progressOfTask[1]} 笔`
      }
      return ''
    },
    getPkText (a, b) {
      if (a === b) return '旗鼓相当'
      if (a > b) return '暂时领先'
      if (a < b) return '暂时落后'
    },
    // 本活动中，哪些轮次的结果看过
    getHadSeenRounds () {
      const data = JSON.parse(localStorage.getItem(LOCAL_STORE_KEY) || '{}')
      if (!data[this.actId]) return []
      return data[this.actId]
    },
    // 看过的结果缓存起来
    setSeenRounds (round) {
      const data = JSON.parse(localStorage.getItem(LOCAL_STORE_KEY) || '{}')
      if (!data[this.actId] || !Array.isArray(data[this.actId])) {
        data[this.actId] = [round]
      } else {
        data[this.actId].push(round)
      }
      localStorage.setItem(LOCAL_STORE_KEY, JSON.stringify(data))
    },
    // 设置顶部内容
    setHeaderContent() {
      setRightTxt("活动规则");
      clickRightTxt(() => {
        this.eventTrack({
          event: "newly_register_rule_button",
          event_field: this.getTrackInfo({}),
        })
        this.$router.push({
          name: `box.actPlaceRule`,
          params: {
            type: 26,
          },
        });
      });
    },
    /**
     * @input hello(world)example(test)
     * @output ['hello', '(world)', 'example', '(test)']
     */
    onSplitStringByParentheses (str) {
      const reg = str.match(/[^()]+|\([^)]+\)/g)
      return reg
    },
    /**
     * @input (world)
     * @output world
     */
    onRemoveTag (str) {
      return str.replace(/[()]/g, '')
    },
    triggerVisible (v, type) {
      if (type !== undefined) {
        this.feedbackType = type
      }
      this.visible = v
    },
    // 继续PK
    onSureContinue () {
      const isWin = this.showTheRound.userRewardVo.type === 1
      this.eventTrack({
        event: "newly_register_pk_result_pop_button",
        event_field: this.getTrackInfo({
          team_name: this.showTheRound[this.showTheRound.userJoinTeam + 'Name'],
          round_name: this.showTheRound.roundName,
          pk_result: isWin ? 1 : 2,
          type: 3,
        }),
      })
      this.triggerVisible(false)
    },
    // 渠道代金券或是积分页
    onGoCheckReward () {
      this.triggerVisible(false)
      const isWin = this.showTheRound.userRewardVo.type === 1
      this.eventTrack({
        event: "newly_register_pk_result_pop_button",
        event_field: this.getTrackInfo({
          team_name: this.showTheRound[this.showTheRound.userJoinTeam + 'Name'],
          round_name: this.showTheRound.roundName,
          pk_result: isWin ? 1 : 2,
          type: this.userReward.rewardType === 1 ? 2 : 1,
        }),
      })
      if (this.userReward.rewardType === 1) {
        this.onGoVoucherDetail()
      } else {
        this.onGoCreditDetail()
      }
    },
    //  跳转积分商城
    onGoCreditDetail() {
      const data = {
        routePath: "/task/CreditStoreActivity",
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    // 跳转代金券
    onGoVoucherDetail() {
      this.dialogVisible = false;
      const data = {
        routePath: "/coupon/CouponManageActivity",
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    getTrackInfo (params = {}) {
      return JSON.stringify({
        activity_id: this.activityInfo.activityId,
        activity_name: this.activityInfo.name,
        round_name: this.curRound.roundName,
        ...params,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';
.pk_game_popup {
  ::v-deep(.van-goods-action-button--first:not(.van-goods-action-button--last)) {
    background: #fff !important;
    border: 1px solid #fe732e !important;
    color: #FE732E !important;
  }
}
</style>